import React from 'react'
import './contact.css'

const Contact = () => (
  <>
    <div className="swmmReact__footer-links">
      <div className="swmmReact__footer-links_logo">
        <p>swmmReact & blcnblu</p>
      </div>
      <div className="swmmReact__footer-links_div">
        <h4>Links</h4>
        <a href="mailto: issac@swmmReact.org">
          <p>Email</p>
        </a>
      </div>
      <div className="swmmReact__footer-links_div">
      </div>
      <div className="swmmReact__footer-links_div">
        <h4>Contact:</h4>
        <p>PO Box 586</p>
        <p>Beaverton, OR 97075</p>
        <p><a href="mailto: issac@swmmReact.org">issac@swmmreact.org</a></p>
      </div>
    </div>

    <div className="swmmReact__footer-copyright">
      <p>@2025 swmmReact/blcnblu. All rights reserved.</p>
    </div>
  </>
)

export default Contact